// extracted by mini-css-extract-plugin
export default {"text":"TextField_text__Lnp1k","text__area":"TextField_text__area__j-gR7"};